import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { isLoggedIn } from "../../features/login/loginSlice";
import { clearNewTransaction, selectNewTransaction } from "../../features/transactionList/transactionsSlice";
import { selectAccounts } from "../../features/manageAccounts/accountsSlice";
import { setConfirmingDeposit } from "../../features/depositForm/depositSlice";

import Sidebar from "../sidebar/Sidebar";
import { selectUser } from "../../features/home/userSlice";

export default function DepositConfirmation() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const loggedIn = useSelector(isLoggedIn);
    const accounts = useSelector(selectAccounts);
    const newTransaction = useSelector(selectNewTransaction);

    const userInfo = useSelector(selectUser);
    const bankId = userInfo.bankId;

    let month;
    let day;
    let year;
    if (newTransaction.id) {
        let transactionDate = newTransaction.transactionDate.split("T")[0].split("-");
        month = transactionDate[1];
        day = transactionDate[2];
        year = transactionDate[0];
    }
    
    useEffect(() => {
        if (!loggedIn) {
            navigate(`../login`);
        }
    }, [loggedIn, navigate])

    const handleClick = () => {
        dispatch(clearNewTransaction());
        dispatch(setConfirmingDeposit(false));
        navigate(`/${bankId}/deposit`);
    }

    return (
        <main>
            <Sidebar />
            {!newTransaction.id ? "" : 
                <section className="deposit-confirmation">
                    <h2>Deposit Confirmation</h2>
                    <h3><span>Deposit Account:</span> {Object.values(accounts).find(account => account.accountId === newTransaction.accountId).accountType} {newTransaction.accountId}</h3>
                    <h3><span>Amount: $</span>{newTransaction.amount.toFixed(2)}</h3>
                    <h3><span>Transaction Date:</span> {`${month}/${day}/${year}`}</h3>
                    <h3><span>Transaction Id:</span> {newTransaction.id}</h3>
                    <button onClick={handleClick}>Make Another Deposit</button>
                </section>}
        </main>
    )
}